export default {
    methods: {
        onRemove() {
            this.$emit('remove-object');
        },
        onDuplicate() {
            this.$emit('duplicate-object');
        }
    }
};
